import React, { useState, useRef } from 'react';
import { MenuProps } from '@material-ui/core/Menu/Menu';

import { ButtonTypes } from '../themes/custom-theme';
import { PopoverMenuClassType } from './PopOverMenu/PopoverMenu';
import { ContextMenuListItem } from '@cube3/cubicle/src/core/molecules/ContextMenu/ContextMenuListItem';
import { iconFiles } from '@cube3/cubicle/src/core/atoms/Icon/files';
import { ContextMenu } from '@cube3/cubicle/src/core/molecules/ContextMenu';
import { isMobile } from 'react-device-detect';
import { MobileSubmenuSlider } from '@cube3/cubicle/src/components/Surface/MobileSubmenuSlider';

interface Properties {
  text: string;
  leftSvgPath?: keyof typeof iconFiles;
  menuIconPath?: string;
  extraMenuProps?: MenuProps;
  variant?: ButtonTypes;
  childrenRenderProps: (closeFn: Function, isOpen: boolean) => JSX.Element;
  classProps?: PopoverMenuClassType;
}

/** Renders an activator button `MenuItem` and its children through a prop. The children are given a closeFn in order to manually trigger a menu close event.  */
export const Submenu: React.FunctionComponent<Properties> = (props) => {
  const [open, setOpen] = useState<boolean>(false);
  const anchorEl = useRef<HTMLButtonElement>(undefined);

  const handleMenuClose = (): void => {
    setOpen(false);
  };

  const { text, childrenRenderProps, leftSvgPath } = props;

  return (
    <>
      {!isMobile ? (
        <div
          onMouseLeave={() => setOpen(false)}
          onMouseOver={() => setOpen(true)}
        >
          {/* Activator */}

          <ContextMenuListItem
            value={text}
            onClick={() => handleMenuClose()}
            leftIcon={leftSvgPath}
            extraRootProps={{
              ref: anchorEl
            }}
            color="02"
            showShortcut={false}
          />

          {/* Contents */}
          {/* Pass the close function so we can acces the close function when implementing the component. */}
          {open && (
            <ContextMenu
              placement="right-start"
              anchor={anchorEl.current}
              width={'100%'}
              scrollbarHeight={400}
              offset={-1}
            >
              {childrenRenderProps(handleMenuClose, open)}
            </ContextMenu>
          )}
        </div>
      ) : (
        <div data-type="librarydeselectoverride">
          {/**prevents item from getting deseleted when the submenu get triggered */}
          <ContextMenuListItem
            value={text}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpen(true);
            }}
            leftIcon={leftSvgPath}
            extraRootProps={{
              ref: anchorEl
            }}
            color="02"
            showShortcut={false}
          />
          {/* Contents */}
          {/* Pass the close function so we can acces the close function when implementing the component. */}
          {open && (
            <MobileSubmenuSlider onClose={handleMenuClose as any}>
              {childrenRenderProps(handleMenuClose, open)}
            </MobileSubmenuSlider>
          )}
        </div>
      )}
    </>
  );
};
